/**
 * Id único para chaves de lista na tela. `crypto.randomUUID` só existe em contexto seguro (HTTPS ou localhost):
 * num servidor acessado por HTTP ele não é uma função e a tela quebra. Aqui usa-se o nativo quando existe e,
 * senão, `crypto.getRandomValues` (disponível também em HTTP) ou, em último caso, `Math.random`.
 */
export function gerarId() {
    const c = typeof window !== "undefined" ? (window.crypto || window.msCrypto) : undefined;

    if (c && typeof c.randomUUID === "function") {
        return c.randomUUID();
    }

    if (c && typeof c.getRandomValues === "function") {
        const bytes = c.getRandomValues(new Uint8Array(16));
        bytes[6] = (bytes[6] & 0x0f) | 0x40; // versão 4
        bytes[8] = (bytes[8] & 0x3f) | 0x80; // variante RFC 4122
        const hex = Array.from(bytes, b => b.toString(16).padStart(2, "0"));
        return `${hex.slice(0, 4).join("")}-${hex.slice(4, 6).join("")}-${hex.slice(6, 8).join("")}-${hex.slice(8, 10).join("")}-${hex.slice(10).join("")}`;
    }

    return `${Date.now().toString(16)}-${Math.random().toString(16).slice(2)}-${Math.random().toString(16).slice(2)}`;
}
